if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
if (document.body.classList.contains('free_pounch')) {
             fetch(`/cart.js`)
              .then((output) => output.json())
              .then((result) => {
                let MaxPricePullUp = result.item_count;
                let Total_count = 0;
                let FreeReceived = false;
                result.items.forEach((item,index)=>{
                  if( item.id != 51251757515026 ){
                    Total_count = parseInt(Total_count) + parseInt(item.quantity);
                  }
                  if(item.id == 51251757515026){
                    FreeReceived = true;
                    return FreeReceived;
                  }
                });
                
                if( (MaxPricePullUp > 1) && !FreeReceived ){
                  console.log('no removed yet');
                  let ProductData = { items: [{ id: 51251757515026, quantity: 1 }] };
                  fetch(window.Shopify.routes.root + 'cart/add.js', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(ProductData),
                  })
                    .then((response) => {
                      return response.json();
                    })
                    .then((results) => {
                      fetch(`${routes.cart_url}?section_id=cart-drawer`)
                        .then((response) => response.text())
                        .then((responseText) => {
                          const html = new DOMParser().parseFromString(responseText, 'text/html');
                          const sourceQty = html.querySelector('#CartDrawer');
                          document.querySelector('#CartDrawer').innerHTML = sourceQty.innerHTML;

                          document.querySelectorAll('[js-image-popup]').forEach((elm)=>{
                            elm.addEventListener('click', (target)=>{
                              target.preventDefault();
                              document.querySelector('.ProductPouch__free_offer').classList.add('active');
                              document.body.classList.add('masked');
                            })
                          })
                          document.querySelectorAll('.overlayProductPouch').forEach((elm)=>{
                            elm.addEventListener('click', (target)=>{
                              target.preventDefault();
                              document.querySelector('.ProductPouch__free_offer').classList.remove('active');
                              document.body.classList.remove('masked');
                            })
                          })
                          document.querySelectorAll('.ProductPouch__cross').forEach((elm)=>{
                            elm.addEventListener('click', (target)=>{
                              target.preventDefault();
                              document.querySelector('.ProductPouch__free_offer').classList.remove('active');
                              document.body.classList.remove('masked');
                            })
                          }) 
                          
                        });
                      fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
                        .then((response) => response.text())
                        .then((responseText) => {
                          const html = new DOMParser().parseFromString(responseText, 'text/html');
                          const sourceQty = html.querySelector('.cart-count-bubble');
                          document.querySelector('.cart-count-bubble').innerHTML = sourceQty.innerHTML;
                        });
                    })
                    .catch((error) => {
                      console.error('Error:', error);
                    })
                  
                }else if( Total_count < 2 && FreeReceived ){
                  console.log('removed yet');
                  let updates = {51251757515026: 0};
                    fetch(window.Shopify.routes.root + 'cart/update.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json'
                      },
                      body: JSON.stringify({ updates })
                    })
                    .then((response) => {
                      return response.json();
                    })
                    .then((results) => {
                      fetch(`${routes.cart_url}?section_id=cart-drawer`)
                        .then((response) => response.text())
                        .then((responseText) => {
                          const html = new DOMParser().parseFromString(responseText, 'text/html');
                          const sourceQty = html.querySelector('#CartDrawer');
                          document.querySelector('#CartDrawer').innerHTML = sourceQty.innerHTML;

                          document.querySelectorAll('[js-image-popup]').forEach((elm)=>{
                            elm.addEventListener('click', (target)=>{
                              target.preventDefault();
                              document.querySelector('.ProductPouch__free_offer').classList.add('active');
                              document.body.classList.add('masked');
                            })
                          })
                          document.querySelectorAll('.overlayProductPouch').forEach((elm)=>{
                            elm.addEventListener('click', (target)=>{
                              target.preventDefault();
                              document.querySelector('.ProductPouch__free_offer').classList.remove('active');
                              document.body.classList.remove('masked');
                            })
                          })
                          document.querySelectorAll('.ProductPouch__cross').forEach((elm)=>{
                            elm.addEventListener('click', (target)=>{
                              target.preventDefault();
                              document.querySelector('.ProductPouch__free_offer').classList.remove('active');
                              document.body.classList.remove('masked');
                            })
                          }) 
                          
                        });
                      fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
                        .then((response) => response.text())
                        .then((responseText) => {
                          const html = new DOMParser().parseFromString(responseText, 'text/html');
                          const sourceQty = html.querySelector('.cart-count-bubble');
                          document.querySelector('.cart-count-bubble').innerHTML = sourceQty.innerHTML;
                        });
                    })
                    .catch((error) => {
                      console.error('Error:', error);
                    })
                  
                }
              })
            
          }
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
